<template>
  <div class="AgentSaleOrderCardContainer shadow mb18 brd8">
    <nut-row class="leftCenter wd100 ft12">
      <nut-tag class="mr6" type="success">{{ data.paidSeqId }}</nut-tag>
      <img :src="data.buyerAvatar" class="sqr20 brd10">
      <nut-ellipsis :content="`${data.buyerName}(from: ${data.agentName})`" :rows="1" class="ft12 mr6 ml6"/>
      <!--      <span class="ml6">{{ data.buyerName }}</span>-->
      <!--      <span class="ml12 mr6" v-if="data.agentName">(from: {{ data.agentName }})</span>-->
      <img src="https://cdn.waityou.online/0fc3746d-6a91-8694-cc2d-f28792c31520.svg"
           v-if="data.payMethod == 'WECHAT_JSAPI'" class="sqr16">
      <img src="https://cdn.waityou.online/34c842cc-48ce-6194-8319-122794fd35f3.svg"
           v-if="data.payMethod == 'ALIPAY_NATIVE'" class="sqr16">
      <img src="https://cdn.waityou.online/1945c1ba-228f-99c3-3c2d-4f051b4f5990.svg"
           v-if="data.payMethod == 'BALANCE_PAY'" class="sqr16">
    </nut-row>
    <nut-row class="bothCenter mt8">
      <nut-col :span="4" class="leftCenter">
        <img :src="data.goodImage"
             class="sqr40 brd8"/>
      </nut-col>
      <nut-col :span="20" class="colFlex">
        <nut-row class="bothCenter">
          <nut-col :span="16" class="leftCenter">
            <nut-ellipsis class="boldFont ft14" :rows="1" :content="data.goodName"/>
          </nut-col>
          <nut-col :span="8" class="rightCenter">
            <span class="ft12">实付:¥{{ (data.amt / 100).toFixed(2) }}</span>
          </nut-col>
        </nut-row>
        <nut-row class="bothCenter">
          <nut-col :span="12" class="leftCenter">
            <span class="ft12 lightText">{{ data.paidTime }}</span>
          </nut-col>
          <nut-col :span="12" class="rightCenter">
            <span class="numberText ft12"
                  v-if="data.refundAmt && data.refundAmt>0">已退款:¥{{ (data.refundAmt / 100.0).toFixed(2) }}</span>
            <span class="numberText ft12" v-if="data.orderState == 'REFUND_CONFIRMING'">退款审批中</span>
          </nut-col>
        </nut-row>
      </nut-col>
    </nut-row>
  </div>
</template>

<script>
export default {
  name: "AgentSaleOrderCard",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.AgentSaleOrderCardContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;

  .receiveBtn {
    padding: 4px 10px;
    border: 1px solid #E76A2C;
    border-radius: 14px;
    background: white;
    color: #E76A2C;
  }

  .delText {
    text-decoration: line-through;
  }
}
</style>